import { useNavigate } from "react-router";
import { publicRoutes } from "@/routing";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearSearchState } from "@/state/searchSlice";
import { getUserProfile, clearProfile } from "@/state/profileSlice";
import { useReturnUrl } from "@/routing";

export const AuthLayout = ({ children }) => {
    const user = useSelector((state) => state.user);
    const navigate = useNavigate();
    const returnUrl = useReturnUrl();
    const dispatch = useDispatch();

    useEffect(() => {
        if (user.data === null) {
            dispatch(clearSearchState());
            dispatch(clearProfile());
            navigate(`${publicRoutes[0].path}?returnUrl=${returnUrl}`);
        }
    }, [user.data, returnUrl]);

    useEffect(() => {
        if (user.data) {
            dispatch(getUserProfile());
        }
    }, [user.data]);

    if (!user.data) {
        return null;
    } else return <>{children}</>;
};
